export const validateNewUser = (user, supplierIds) => {
  const newErrors = {};

  if (!user.username.trim()) {
    newErrors.username = 'Benutzername ist erforderlich';
  } else if (user.username.length < 3) {
    newErrors.username = 'Benutzername muss mindestens 3 Zeichen lang sein';
  }

  if (!user.password) {
    newErrors.password = 'Passwort ist erforderlich';
  } else if (user.password.length < 8) {
    newErrors.password = 'Passwort muss mindestens 8 Zeichen lang sein';
  }

  if (!user.email.trim()) {
    newErrors.email = 'E-Mail ist erforderlich';
  } else if (!/\S+@\S+\.\S+/.test(user.email)) {
    newErrors.email = 'Ungültige E-Mail-Adresse';
  }

  if (!user.fullName.trim()) {
    newErrors.fullName = 'Name ist erforderlich';
  }

  if (user.phone && user.phone.trim() && !/^\+?[0-9\s\-().]{7,20}$/.test(user.phone.trim())) {
    newErrors.phone = 'Ungültige Telefonnummer';
  }

  if (!supplierIds || supplierIds?.length === 0) {
    newErrors.supplierIds = 'Mindestens ein Lieferant muss ausgewählt werden';
  }

  return newErrors;
};

export const validateLogin = (user) => {
  const newErrors = {};

  if (!user.username.trim()) {
    newErrors.username = 'Benutzername ist erforderlich';
  } else if (user.username.length < 3) {
    newErrors.username = 'Login fehlgeschlagen';
  }

  if (!user.password) {
    newErrors.password = 'Passwort ist erforderlich';
  } else if (user.password.length < 8) {
    newErrors.password = 'Login fehlgeschlagen';
  }

  return newErrors;
};